<template>
  <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
    <a-form-item label="批次" name='batch_sn'>
      <a-input v-model:value="search.batch_sn"></a-input>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
    <template v-slot:action="{ record }" >
      <a-button type="primary" @click='select(record)' v-if='!checkout&&record.is_show_select' :ghost="!record.select">{{!record.select ? "选择":"已选择"}}</a-button>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
  <div class="s_flex_center m-t-10" v-if='checkout'>
    <a-button type="primary" @click='confirm'>确定</a-button>
  </div>
  <a-modal :keyboard="false" v-model:visible="visible" centered :width='1300' destroyOnClose :footer="null">
    <p>批次:{{batchData.batch_sn}}</p>
    <p>流水号:{{batchData.small_serial_start}}-{{batchData.small_serial_end}}</p>
    <p>可用流水号（其他提货券未使用的流水号，本次添加的流水号不记录在内）</p>
    <p>
      <span v-for="(value,key) in  batchData.available_range" :key="key" class="m-r-10">({{value.small_serial_start}}-{{value.small_serial_end}})</span>
    </p>
    <a-form ref="form" :model='batchForm' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange'>
      <a-form-item label="设置流水号" name='voucher_id' v-if="batchData.is_show_all">
        <a-radio-group v-model:value="batchForm.is_all">
          <a-radio :value="1">
            全部流水号
          </a-radio>
          <a-radio :value="0">
            部分流水号
          </a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="起始流水号" name='start' v-if="!batchForm.is_all">
        <a-input placeholder="请输入流水号" style="width:200px" v-model:value="batchForm.small_serial_start" @blur="startHandle" />
      </a-form-item>
      <a-form-item label="结束流水号" name='end' v-if="!batchForm.is_all">
        <a-input placeholder="请输入流水号" style="width:200px" v-model:value="batchForm.small_serial_end" :disabled="!batchForm.small_serial_start" @blur="endHandle" />
      </a-form-item>
      <a-form-item v-if="batchForm.small_serial_end">
        区间数量:{{Number(batchForm.small_serial_end)-Number(batchForm.small_serial_start)+1}}
      </a-form-item>
         <a-form-item>
        <a-button class="m-r-10" @click="visible=false">重新选择批次</a-button> <a-button @click="submitBatch">确定</a-button>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { getVoucherList,setVoucherBatchList, getVoucherBatchList } from "@/api/assets";

import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defSearch = {
  batch_sn: "",
  page: 1,
  limit: 5,
};
export default {
  name: "selectPickUpCode",
  components: {},
  props: {
    dealer_id: {
      type: Number || String,
    },
    selectList: {
      type: Array,
    },
    checkout: {
      type: Boolean,
    },
    hiddenHead: {
      type: Boolean,
    },
    id: {
      type: String,
    },
  },
  setup(props, { emit }) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    let form =ref()
    let batchForm = ref({
      small_serial_start: 0,
      small_serial_end: 0,
      is_all: false,
    });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      listLoading: false,
      total: 1,
      selectList: [],
      checkout: false,
      visible: false,
    });
    let columns = [
      {
        title: "批次",
        dataIndex: "batch_sn",
        key: "batch_sn",
      },
      {
        title: "流水号区间",
        dataIndex: "small_serial_end",
        key: "small_serial_end",
        customRender: ({ record }) => {
          return record.small_serial_start + "-" + record.small_serial_end;
        },
      },
      {
        title: "数量",
        dataIndex: "small_code_counts",
        key: "small_code_counts",
      },
      {
        title: "添加时间",
        dataIndex: "clerk_name",
        key: "clerk_name",
      },
      {
        title: "生码说明",
        dataIndex: "clerk_phone",
        key: "clerk_phone",
      },
      {
        title: "操作",
        key: "action",
        width: 120,
        slots: { customRender: "action" },
      },
    ];
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    //选择
    const batchData = ref({});
    const select = (e) => {
      batchData.value = e;
      batchForm.value = {
        small_serial_start: null,
        small_serial_end: null,
        is_all: 1,
      };
      if (e.available_range.length) {
        batchForm.value.is_all = 0;
      }
      state.visible = true;
    };
    const initData = async (values) => {
      state.listLoading = true;
      try {
        let res = await getVoucherBatchList({
          ...values,
          voucher_id: props.id,
        }).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
          if (props.checkout) {
            state.checkout = props.checkout;
          }
          if (state.selectList || state.selectList.length > 0) {
            data.value.forEach((i) => {
              if (
                state.selectList.find((v) => {
                  return i.id == v.id || i.id == v.store_id;
                })
              ) {
                i.select = true;
              }
            });
          }
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    onMounted(() => {
      if (props.selectList) {
        state.selectList = JSON.parse(JSON.stringify(props.selectList));
      }
      initData(search.value);
    });
    const startHandle = (e) => {
      if (isNaN(Number(e.target.value))) {
        batchForm.value.small_serial_start.value = "";
        batchForm.value.small_serial_end.value = "";
      }
      if(!e.target.value){
        batchForm.value.small_serial_end.value = "";
      }
      return true;
    };
    const endHandle = (e) => {
      if (isNaN(Number(e.target.value))) {
        batchForm.value.small_serial_end.value = "";
      }
      if (Number(batchForm.value.small_serial_start) > Number(e.target.value)) {
        message.error("结束流水号要大于开始流水号");
        batchForm.value.small_serial_end.value = "";
      return false;
      }
      return true;
    };
    const submitBatch=async()=>{
        if (batchForm.value.is_all==0&&Number(batchForm.value.small_serial_start) > Number(batchForm.value.small_serial_endt)){
            message.error("结束流水号要大于开始流水号");
              return 
        }else if(batchForm.value.is_all==1){
          batchForm.value.small_serial_start=batchData.value.small_serial_start
          batchForm.value.small_serial_end=batchData.value.small_serial_end
        }
         const hide = message.loading('正在加载中...', 0);
      let result=await setVoucherBatchList({
        ...batchForm.value,
        voucher_id:props.id,
        batch_sn:batchData.value.batch_sn
      }).then(res=>res.data).catch(error=>error)
            setTimeout(hide);
      if(iscode(result,true)){
        emit('done')
        state.visible = false
      }
    }
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      select,
      batchData,
      startHandle,
      endHandle,
      form,
      batchForm,
      submitBatch
    };
  },
};
</script>